import isEmpty from "../helpers/isEmpty";
//------------------
// strip delimiters
//------------------
export default function stripDelimiters(str) {
  // console.log("----------------------");
  // console.log("IN stripDelimiters = " + str);
  var return_str = "";

  if (!isEmpty(str)) {
    const delims = / |-|'|_/;
    let words = str.split(delims);
    // join words together
    return_str = words.join(" ");

    // console.log("stripped str = " + return_str);
    // console.log("----------------------");
  }
  return return_str;
}
